module.exports = __webpack_public_path__ + "img/Operational Gateway Icon.0130fd9e.png";